var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"map-header__title"},[_c('h1',{staticClass:"map-header__title__header",domProps:{"innerHTML":_vm._s(_vm.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }